import React, { useContext, useState } from "react";

import {
  manageDistributionFormNames,
  distributionFormFields,
  MANAGE_DISTRIBUTION_ROUTES,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
  usDateFormat,
  MANAGE_CENSUS_ROUTES,
  getAdvancedPathWithParam,
} from "../../../utils";
import { Field, Form, Formik, isEmptyArray } from "formik";
import {
  appLayoutStore,
  globalToastInfo,
  manageDistributionStore,
  manageTransactionStore,
  setWithdrawalRequestPageData,
} from "../../../contexts";
import { setManageTransactionToastInfo } from "./../../../contexts/reducers/manage-transaction/actions";

import {
  FieldDropSide,
  FieldInputPercentage,
  FieldTextarea,
  SearchableList,
  DatePicker,
  LoanSummaryCard,
  WarningModal,
} from "../../../components";
import {
  loanRefinance,
  loanSuspension,
  ResumeSuspendedLoan,
} from "../../../services";
import { Button, Toast } from "react-bootstrap";
import * as Yup from "yup";
import { values } from "lodash";
import moment from "moment";
import { useRouterParams } from "../../../abstracts";
import { useHistory } from "react-router";
const initialValues = {
  // reasonForSuspension: null,
  // reasonForSuspensionOthersReason: "",
  // suspensionInterestRate:null,
  // // suspensionStartDate: null,
  // suspensionEndDate: null,
};

const LoanSuspensionRequest = ({
  setLoanSuspensionSlider,
  loanData,
  planData,
  loanSettingInfo,
  employeeInfo,
  principalPaid,
  calculateTotalNoOfInstallments,
  loanStatus,
  setTrigger,
  trigger,
  showClose = false,
  setShowClose,
  resume,
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const formName = manageDistributionFormNames.LOAN_SUSPENSION_REQUEST;
  const fields = distributionFormFields[formName];
  const onFormSubmit = (values) => {
    const value = values;
    value.loanId = loanData.id;
    // const value = {...values,loanId:loanData.loanId}
    // if (loanStatus == "Suspended") {
    //   const val = { loanId: 5 };
    //   val.loanId = loanData.id;
    //   ResumeSuspendedLoan(val);
    // } else {
    //   loanSuspension(value);
    setModalVisible(true);
    // }
    // setModalVisible(false)
    // setLoanSuspensionSlider(false);
  };
  console.log("loandata", loanData);
  const today = new Date();
  function getPreviousDay(date = new Date()) {
    const previous = new Date(date.getTime());
    previous.setDate(date.getDate() - 1);

    return previous;
  }
  const history = useHistory();
  const { state, dispatch } = useContext(appLayoutStore);
  const previous = getPreviousDay();
  const { flow, censusId } = useRouterParams();
  // const suspensionStartDateNext=values["suspensionStartDate"].getTime();
  // suspensionStartDateNext.setDate(suspensionStartDateNext.getDate()-1);

  const validationSchema = Yup.object({
    suspensionInterestRate: Yup.number().required("LS03 : Required").nullable(),
    // reasonForSuspensionOthersReason:Yup.string().when(['reasonForSuspension',, {
    //      is: "2",
    //      then: Yup.string().required('LS02 : Required')}).nullable()
    //      ,
    reasonForSuspension: Yup.number().required("LS01 : Required").nullable(),
    suspensionStartDate: Yup.date()
      .required("LS04 : Required")
      .min(previous, "LS05 : Enter current or future date")
      .nullable(),
    //  suspensionEndDate:Yup.date()
    //  .min(Yup.ref('suspensionStartDate'),"LS06 : Suspension End date has to be later than the suspension start date")
    // //  .when(["suspensionStartDate", "suspensionEndDate"], {
    // //   is: (suspensionStartDate, suspensionEndDate) => {
    // //     return suspensionStartDate.getDate() >= suspensionEndDate.getDate();
    // //   },
    // //   then: Yup.date().required("bla"),
    // // })
    // .nullable(),

    //  .min(Yup.ref('suspensionStartDate'),"LS06 : Suspension End date has to be later than the suspension start date")
    //  .nullable()
    // // .when(values["suspensionStartDate"], {
    // //   is: !null,
    // //   then: Yup.string().required('Must enter email address'),
    // }),
    // suspensionEndDate:Yup.date()
    // .test(
    //   "suspensionEndDate",
    //   "Please choose a valid date of birth",
    //   ()=>values["suspensionStartDate"]>=values["suspensionEndDate"]
    // )
  });

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={onFormSubmit}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={validationSchema}
      >
        {(formProps) => {
          const {
            handleChange,
            setFieldValue,
            handleSubmit,
            setValues,
            setTouched,
            values,
            setSubmitting,
            setFieldError,
            fieldValue,
            errors,
            handleBlur,
            ...rest
          } = formProps;
          const onDaySelected = (fieldName, value) => {
            setFieldValue(fieldName, value);
          };
          const reasonForSuspensionOthersReasonValidaton = (value) => {
            let error;
            if (!value) {
              error = "LS02 : Required";
              return error;
            }
          };

          const suspensionEndDateValidation = (value) => {
            let error;
            if (value != null) {
              if (!(value > values["suspensionStartDate"])) {
                error =
                  "LS06 : Suspension End date has to be later than the suspension start date";
              }
              return error;
            }
          };
          return (
            <Form>
              <div className="d-flex justify-content-between align-baseline">
                <div className="plan-heading font-weight-500">
                  Loan suspension
                </div>
                {showClose ? (
                  <Button
                    variant={"secondary"}
                    onClick={() => {
                      setShowClose(!showClose);
                      setLoanSuspensionSlider(false);
                    }}
                  >
                    Close
                  </Button>
                ) : (
                  <div className="d-flex mt-10">
                    <Button
                      variant={"secondary"}
                      onClick={() => setLoanSuspensionSlider(false)}
                    >
                      Cancel
                    </Button>
                    <div className={"ml-3"}>
                      {loanStatus != "Suspended" ? (
                        <Button
                          variant={"primary"}
                          // onClick={() =>  setModalVisible(true)
                          // }
                          //   const value = {...values,loanId:loanData.loanId}
                          //   loanSuspension(value);
                          // }}
                          type="submit"
                        >
                          {loanStatus == "Suspended" ? (
                            <>Resume</>
                          ) : (
                            <>Submit</>
                          )}
                        </Button>
                      ) : (
                        <Button
                          variant={"primary"}
                          onClick={() => {
                            // const val = { loanId: 5 };
                            // val.loanId = loanData.id;
                            setModalVisible(true);
                            // ResumeSuspendedLoan(val);
                            // setLoanSuspensionSlider(false);
                          }}
                        >
                          {loanStatus == "Suspended" ? (
                            <>Resume</>
                          ) : (
                            <>Submit</>
                          )}
                        </Button>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <LoanSummaryCard
                loanData={loanData}
                planData={planData}
                loanSettingInfo={loanSettingInfo}
                employeeInfo={employeeInfo}
                principalPaid={principalPaid}
                calculateTotalNoOfInstallments={calculateTotalNoOfInstallments}
              />
              <div className="loansuspension">
                {loanStatus == "Suspended" ? (
                  <>
                    <div className="loanrefinancelabel">
                      Reason For Suspension
                    </div>
                    <div
                      className="mb-4"
                      style={{ fontWeight: "500", color: "#242426" }}
                    >
                      {
                        OPTIONS_DATA_MAPPER.REASON_FOR_LOAN_SUSPENSION[
                          loanData.loanSuspension.reasonForSuspension
                        ]
                      }
                    </div>
                  </>
                ) : (
                  <Field
                    size="md"
                    isRequired
                    label="Reason For Suspension"
                    name={fields.reasonForSuspension}
                    value={values[fields.reasonForSuspension]}
                    // disabled={isEdit && !isSave}
                    options={toOptionValuesFromMapper(
                      OPTIONS_DATA_MAPPER.REASON_FOR_LOAN_SUSPENSION
                    )}
                    popupContent={
                      <SearchableList
                        label="Select the reason"
                        isNotTypeAhead
                        isRadio
                        selectedValue={values[fields.reasonForSuspension]}
                        options={toOptionValuesFromMapper(
                          OPTIONS_DATA_MAPPER.REASON_FOR_LOAN_SUSPENSION
                        )}
                        onSelect={(value) =>
                          setFieldValue(fields.reasonForSuspension, value)
                        }
                      />
                    }
                    component={FieldDropSide}
                  />
                )}

                {loanStatus == "Suspended" &&
                loanData.loanSuspension.reasonForSuspension === 3 ? (
                  <>
                    <div className="loanrefinancelabel">Enter Reason</div>
                    <div
                      className="mb-4"
                      style={{ fontWeight: "500", color: "#242426" }}
                    >
                      {loanData.loanSuspension.reasonForSuspensionOthersReason}
                    </div>
                  </>
                ) : (
                  <>
                    {values[fields.reasonForSuspension] === 3 ? (
                      <Field
                        name={fields.reasonForSuspensionOthersReason}
                        label="Enter Reason"
                        isRequired
                        autoComplete="off"
                        value={values[fields.reasonForSuspensionOthersReason]}
                        onChange={handleChange}
                        // disabled={isEdit}
                        component={FieldTextarea}
                        validate={reasonForSuspensionOthersReasonValidaton}
                        size="lg"
                      />
                    ) : null}
                  </>
                )}
                {/* {errors.reasonForSuspensionOthersReason && <div>{errors.reasonForSuspensionOthersReason}</div>} */}

                {loanStatus == "Suspended" ? (
                  <>
                    <div className="loanrefinancelabel">
                      Suspension Interest Rate
                    </div>
                    <div
                      className="mb-4"
                      style={{ fontWeight: "500", color: "#242426" }}
                    >
                      {loanData.loanSuspension.suspensionInterestRate} %
                    </div>
                  </>
                ) : (
                  <Field
                    size="xxs"
                    isRequired
                    name={fields.suspensionInterestRate}
                    type="number"
                    label={"Suspension Interest Rate"}
                    autoComplete="off"
                    onChange={formProps.handleChange}
                    max={100.0}
                    min={0}
                    value={values[fields.suspensionInterestRate]}
                    component={FieldInputPercentage}
                    // disabled={isEdit && !isSave}
                  />
                )}

                {loanStatus == "Suspended" ? (
                  <>
                    <div className="loanrefinancelabel">
                      Suspension Start Date
                    </div>
                    <div
                      className="mb-4"
                      style={{ fontWeight: "500", color: "#242426" }}
                    >
                      {usDateFormat(
                        loanData.loanSuspension.suspensionStartDate
                      )}
                    </div>
                  </>
                ) : (
                  <Field
                    name={fields.suspensionStartDate}
                    isRequired
                    label="Suspension Start Date"
                    size="smd"
                    //   {...rest}
                    value={usDateFormat(values[fields.suspensionStartDate])}
                    //   disabled={isEdit && !isSave}
                    isDatePicker
                    onClear={() => {
                      setFieldValue(fields.suspensionEndDate, null);
                      setFieldValue(fields.suspensionStartDate, null);
                    }}
                    popupContent={
                      <DatePicker
                        onDayClick={(value) =>
                          onDaySelected(fields.suspensionStartDate, value)
                        }
                        value={usDateFormat(values[fields.suspensionStartDate])}
                      />
                    }
                    component={FieldDropSide}
                  />
                )}

                {loanStatus == "Suspended" ? (
                  <>
                    <div className="loanrefinancelabel">
                      Suspension End Date
                    </div>
                    <div
                      className="mb-3"
                      style={{ fontWeight: "500", color: "#242426" }}
                    >
                      {usDateFormat(loanData.loanSuspension.suspensionEndDate)}
                    </div>
                  </>
                ) : (
                  <Field
                    name={fields.suspensionEndDate}
                    label="Suspension End Date"
                    {...rest}
                    value={usDateFormat(values[fields.suspensionEndDate])}
                    //   disabled={isEdit && !isSave}
                    isDatePicker
                    onClear={() =>
                      setFieldValue(fields.suspensionEndDate, null)
                    }
                    popupContent={
                      <DatePicker
                        onDayClick={(value) =>
                          onDaySelected(fields.suspensionEndDate, value)
                        }
                        value={usDateFormat(values[fields.suspensionEndDate])}
                      />
                    }
                    component={FieldDropSide}
                    validate={suspensionEndDateValidation}
                  />
                )}

                {/* {errors.suspensionEndDate && <div>{errors.suspensionEndDate}</div>} */}
                <WarningModal
                  show={modalVisible}
                  onHide={() => setModalVisible(false)}
                >
                  <div className="remove-text">
                    {/* <h4>Are you sure?</h4> */}
                    <p>
                      {loanStatus != "Suspended" ? (
                        <>Are you sure you want to suspend loan</>
                      ) : (
                        <>Are you sure you want to revoke suspension for loan</>
                      )}{" "}
                      - {loanData.loanIdentifier ?? "L001"} ?
                    </p>
                    {loanStatus != "Suspended" ? (
                      <Button
                        className="remove-btn mr-4"
                        onClick={() => {
                          const value = values;
                          value.loanId = loanData.id;
                          setModalVisible(false);
                          loanSuspension(value).then((_) => {
                            setTrigger(!trigger);
                            setLoanSuspensionSlider(false);
                          });
                        }}
                      >
                        Yes
                      </Button>
                    ) : (
                      <Button
                        className="remove-btn mr-4"
                        onClick={() => {
                          const val = { loanId: 5 };
                          val.loanId = loanData.id;
                          setModalVisible(false);
                          ResumeSuspendedLoan(val).then((_) => {
                            dispatch(
                              globalToastInfo({
                                showToast: true,
                                toastMessage: `Loan is active. The ${loanData.loanType} loan - $ ${loanData.outstandingBalance} is active.`,
                              })
                            );
                            // dispatch(
                            //   setManageTransactionToastInfo({
                            //     showToast: true,
                            //     toastMessage: "Loan is active.",
                            //     toastMessage2: `The ${loanData.loanType} - ${loanData.outstandingBalance} is active.`,
                            //   })
                            // );
                            setLoanSuspensionSlider(false);
                            // setTrigger(!trigger);
                            history.push(
                              getAdvancedPathWithParam({
                                path:
                                  MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
                                pathParam: [flow, censusId],
                              })
                            );
                          });
                        }}
                      >
                        Yes
                      </Button>
                    )}
                    <Button
                      className="cancel-btn"
                      onClick={() => setModalVisible(false)}
                    >
                      No
                    </Button>
                  </div>
                </WarningModal>
              </div>
              {/* <button>Submit</button> */}
            </Form>
          );
        }}
      </Formik>
    </>
  );
};
export default LoanSuspensionRequest;
